import { PageHeader } from "@/components/common/PageHeader";
import { Settings as SettingsIcon } from "@mui/icons-material";

import { useMemo } from "react";
import {
  Business,
  Person,
  PictureAsPdf,
  IntegrationInstructions,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useViewContext } from "../../contexts/ViewContext";
import { useSessionContext } from "../../contexts/SessionContext";
import { PageHub } from "@/components/common/PageHub";

export function Settings() {
  const navigate = useNavigate();
  const { availableRoles } = useViewContext();
  const { access } = useSessionContext();

  const cards = useMemo(
    () => [
      {
        title: "Profissionais",
        icon: <Person fontSize="large" sx={{ color: "primary800.main" }} />,
        description: "Gerencie os profissionais de sua clínica",
        onClick: () => navigate("/practitioners"),
        enabled: true,
      },
      {
        title: "Documentos",
        icon: <PictureAsPdf fontSize="large" sx={{ color: "primary800.main" }} />,
        description: "Personalize os documentos emitidos da clínica",
        onClick: () => navigate("/pdf"),
        enabled:
          availableRoles?.includes("manager") ||
          availableRoles?.includes("owner"),
      },
      {
        title: "Clínica",
        icon: <Business fontSize="large" sx={{ color: "primary800.main" }} />,
        description:
          "Informações básicas e opções de gerenciamento da sua clínica",
        onClick: () => navigate("/clinic"),
        enabled: true,
      },
      {
        title: "Exposição de agendas",
        icon: (
          <IntegrationInstructions
            fontSize="large"
            sx={{ color: "primary800.main" }}
          />
        ),
        description: "Configure e gerencie integrações de agendamento",
        onClick: () => navigate("/scheduleintegration"),
        enabled:
          access?.type === "professional" &&
          (availableRoles?.includes("manager") ||
            availableRoles?.includes("owner")),
      },
    ],
    [access?.type, availableRoles, navigate],
  );

  return (
    <PageHub
      header={<PageHeader title="Configurações" icon={SettingsIcon} centered />}
      sections={[
        {
          cards,
        },
      ]}
    />
  );
}
